import { APP_BASE_HREF, registerLocaleData } from '@angular/common';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import localeEnGb from '@angular/common/locales/en-GB';
import localeFi from '@angular/common/locales/fi';
import localeFr from '@angular/common/locales/fr';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment as env } from '../environments/environment';
import { AppRoutingModule } from './app.routing.module';
import { AppComponent } from './app.component';
import { CartSummaryComponent } from './components/cart-summary/cart-summary.component';
import { DeliveryDetailsComponent } from './components/delivery-details/delivery-details.component';
import { HeaderComponent } from './components/header/header.component';
import { MenuComponent } from './components/menu/menu.component';
import { PackageListComponent } from './components/package-list/package-list.component';
import { ProductListComponent } from './components/product-list/product-list.component';
import { ProductComponent } from './components/product/product.component';
import { PackageListTableComponent } from './components/package-list-table/package-list-table.component';
import { SearchComponent } from './components/search/search.component';
import { ItemListComponent } from './components/item-list/item-list.component';
import { CartComponent } from './pages/cart/cart.component';
import { OrderConfirmationComponent } from './pages/order-confirmation/order-confirmation.component';
import { ProductsComponent } from './pages/products/products.component';
import { ItemComponent } from './components/item/item.component';
import { TerminalsComponent } from './pages/terminals/terminals.component';
import { FilterComponent } from './components/filter/filter.component';
import { FilterDialogComponent } from './components/filter/filter-dialog/filter-dialog.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { LoadingBarComponent } from './components/loading-bar/loading-bar.component';
import { RequestsInterceptor } from './interceptors/requests.interceptor';
import { LoadingService } from './services/loading.service';
import { AppMaterialModule } from './app.material.module';
import { CustomBreakPointsProvider } from './app.breakpoints';
import { LoadplanningDialogComponent } from './components/loadplanning-dialog/loadplanning-dialog.component';
import { TruckComponent } from './components/truck/truck.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { SortButtonComponent } from './components/sort-button/sort-button.component';
import { PackageDialogComponent } from './components/package-list/package-dialog/package-dialog.component';
import { PackageCardComponent } from './components/package-list/package-card/package-card.component';
import { HighlightPipe } from './pipes/highlight.pipe';
import { FooterComponent } from './components/footer/footer.component';
import { MatDialogModule } from '@angular/material/dialog';

// locales
registerLocaleData(localeEnGb, 'en-GB');
registerLocaleData(localeFi, 'fi');
registerLocaleData(localeFr, 'fr');
export function translateLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, env.basePath + '/assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    ItemComponent,
    ItemListComponent,
    LoadingBarComponent,
    ProductListComponent,
    ProductsComponent,
    ProductComponent,
    TerminalsComponent,
    PackageListComponent,
    PackageListTableComponent,
    MenuComponent,
    CartSummaryComponent,
    CartComponent,
    DeliveryDetailsComponent,
    OrderConfirmationComponent,
    SearchComponent,
    FilterComponent,
    FilterDialogComponent,
    LoadplanningDialogComponent,
    TruckComponent,
    PaginatorComponent,
    SortButtonComponent,
    PackageDialogComponent,
    PackageCardComponent,
    HighlightPipe,
    FooterComponent,
  ],
  imports: [
    AppRoutingModule,
    MatDialogModule,
    BrowserAnimationsModule,
    BrowserModule,
    FlexLayoutModule.withConfig({ disableDefaultBps: true }),
    FormsModule,
    AppMaterialModule,
    HttpClientModule,
    NgxSliderModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: translateLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: RequestsInterceptor, multi: true, deps: [LoadingService] },
    { provide: LOCALE_ID, deps: [TranslateService], useValue: 'en-GB', useFactory: () => 'en-GB' },
    { provide: APP_BASE_HREF, useValue: env.basePath },
    CustomBreakPointsProvider,
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }
